import { LocalizedTextModel } from "src/app/admin/product-services/shared/models/LocalizedTextModel";

export class ChecklistItemReuqestModel {
    checklistId: number = 0;
    serviceId: number = 0;
    checklistItem: string = '';
    link: string = '';
    linkName: string = '';
    sortValue: number = 0;
    localizedChecklistItem: LocalizedTextModel[] = [];
    localizedLinkName: LocalizedTextModel[] = [];
    localizedRowId?: string;
}
